export const sortTeamsByPoints = (teamA: Team, teamB: Team) => {
  const teamAPoints = teamA.points ?? 0;
  const teamBPoints = teamB.points ?? 0;
  return teamAPoints < teamBPoints ? 1 : -1;
};
